
/**
 * 針對 問卷基本檔.xlsx 每個 column 的定義規則(轉檔時應該怎麼從 MetaTable 中找到對應的數值)
 */
export class HisBasicColDefine {



  /** 匯出目的欄位的欄位名稱 */

  private xls_col_name: string;
  getXlsColName() {
    return this.xls_col_name;
  }

  private his_code: string;
  getHisCode(): string {
    if (this.his_code === '') {
      alert("6443123 請設定 " + this.xls_col_name + " 的 his_code !!!");
    }

    return this.his_code;
  }

  /** 匯出資料格式 (一般通用格式 或 自訂規則) */
  data_type: HisBasicColDefine_DataType;

  //-----------------------------------------------------

  constructor(xls_col_name: string, his_code: string, data_type: HisBasicColDefine_DataType) {
    this.xls_col_name = xls_col_name;
    this.his_code = his_code;
    this.data_type = data_type;
  }
}


export type HisBasicColDefine_DataType = 'string' | 'date' | 'number' | 'radio' | 'custom';// 'custom'自訂規則




//#region 解碼定義檔(依此步驟解碼)


export const COL_性別 = '性別';
export const COL_公司編號 = '公司編號';
export const COL_作業編號 = '作業編號';
export const COL_是否輪班 = '是否輪班';

export const COL_曾經從事 = '曾經從事';

export const COL_目前從事開始月 = '目前從事開始月';// 要將 {目前從事開始日} 改為民國年月 如: 10901
export const COL_工作班別 = '工作班別';// 工作班別 1:固定班別  2:輪班
export const COL_其它輪班班別 = '其它輪班班別';

export const COL_上班時間 = '上班時間';
export const COL_下班時間 = '下班時間';


export const HisBasicColDefine_輪班幾班制 = new HisBasicColDefine('輪班幾班制', '{輪班幾班制}', 'radio');

export const BOO_ColDefineList: HisBasicColDefine[] = [
  new HisBasicColDefine('檢查日期', '{檢查日期}', 'date'),

  new HisBasicColDefine(COL_公司編號, '', 'custom'),
  new HisBasicColDefine(COL_作業編號, '', 'custom'),

  new HisBasicColDefine('身份證號', '{身份證號}', 'string'),
  new HisBasicColDefine(COL_性別, '{性別}', 'custom'),
  new HisBasicColDefine('姓名', '{姓名}', 'string'),
  new HisBasicColDefine('生日', '{生日}', 'date'),

  new HisBasicColDefine('受雇日期', '{受雇日期}', 'date'),

  new HisBasicColDefine(COL_曾經從事, '{曾經從事}', 'custom'),
  new HisBasicColDefine('曾經從事開始日', '{曾經從事開始日}', 'date'),
  new HisBasicColDefine('曾經從事結束日', '{曾經從事結束日}', 'date'),

  new HisBasicColDefine('目前從事', '{目前從事}', 'string'),
  new HisBasicColDefine('目前從事開始日', '{目前從事開始日}', 'date'),
  new HisBasicColDefine('目前從事結束日', '{目前從事結束日}', 'date'),

  new HisBasicColDefine('一個月平均工時', '{一個月平均工時}', 'number'),
  new HisBasicColDefine('六個月平均工時', '{六個月平均工時}', 'number'),
  new HisBasicColDefine('平均睡眠時間', '{平均睡眠時間}', 'number'),

  new HisBasicColDefine('本作業平均工時', '{本作業平均工時}', 'number'),

  new HisBasicColDefine(COL_是否輪班, '', 'custom'),
  HisBasicColDefine_輪班幾班制,
  new HisBasicColDefine('輪班幾班制_其他', '{輪班幾班制_其他}', 'string'),



];


export const A98_ColDefineList: HisBasicColDefine[] = [

  new HisBasicColDefine('檢查日期', '{檢查日期}', 'date'),

  new HisBasicColDefine(COL_公司編號, '', 'custom'),
  new HisBasicColDefine(COL_作業編號, '', 'custom'),

  new HisBasicColDefine('身份證號', '{身份證號}', 'string'),
  new HisBasicColDefine('生日', '{生日}', 'date'),

  new HisBasicColDefine('受雇日期', '{受雇日期}', 'date'),


  new HisBasicColDefine('目前從事', '{目前從事代碼}', 'string'),

  new HisBasicColDefine(COL_目前從事開始月, '{目前從事開始日}', 'custom'),// 特殊規則:  改為民國yyyMM: 11203 
  new HisBasicColDefine('特殊危害健康作業編號', '{特殊危害健康作業編號}', 'string'),

  new HisBasicColDefine('一個月平均工時', '{一個月平均每日工時}', 'number'),
  new HisBasicColDefine('一個月夜間工作日數', '{一個月夜間工作日數}', 'number'),

  new HisBasicColDefine('六個月平均工時', '{六個月平均每日工時}', 'number'),
  new HisBasicColDefine('六個月夜間工作日數', '{六個月夜間工作日數}', 'number'),

  new HisBasicColDefine('一年內夜間工時', '{一年內夜間工時}', 'number'),
  new HisBasicColDefine('一年內夜間工作日數', '{一年內夜間工作日數}', 'number'),

  new HisBasicColDefine(COL_工作班別, '', 'custom'),
  new HisBasicColDefine(COL_其它輪班班別, '{輪班幾班制}', 'custom'),

  new HisBasicColDefine(COL_上班時間, '{上班時間}', 'custom'),
  new HisBasicColDefine(COL_下班時間, '{下班時間}', 'custom'),

  new HisBasicColDefine('工作日平均睡眠時間', '{平均睡眠時間}', 'number'),
  new HisBasicColDefine('休息日平均睡眠時間', '{休息日平均睡眠時間}', 'number'),

];


//#endregion



